import { onlineManager } from '@tanstack/react-query'
import { Outlet, createFileRoute } from '@tanstack/react-router'
import ConfirmCancelBooking from '@/components/my-booking/ConfirmCancelBooking'
import { queryKeys } from '@/queries/keys'
import { getCancellationsQueryOptions } from '@/queries/query/cancellation'

export const Route = createFileRoute('/my-booking/$id/cancel/confirm')({
  loader: ({ context }) => {
    if (onlineManager.isOnline() && !context.isRestoring) {
      return context.queryClient.ensureQueryData(getCancellationsQueryOptions())
    }
    return context.queryClient.getQueryData(
      queryKeys.cancellation.cancellations(),
    )
  },
  component: RouteComponent,
})

function RouteComponent() {
  const bookingId = Route.useParams({
    select: (s) => s.id,
  })
  return (
    <>
      <ConfirmCancelBooking bookingId={bookingId} />
      <Outlet />
    </>
  )
}
